<div  class="voting_item" [ngClass]="{dateSortItem:listReorderService.sortBy==='date'}"  >
  <div class="content filter opacity_target">
    <div class="small author">{{ authorLocation }}</div>
    <div>
      {{question['txt_'+activeLanguage] ? question['txt_'+activeLanguage] : question.txt_raw}}
    </div>
  </div>
  @if(user_vote_questions){
    <div class="opacity_target">
      <div class="small alignEnd" *ngIf="listReorderService.sortBy==='date'">{{question?.date_of_approval | date :'HH:mm'}}</div>
      <div [ngClass]="{'highlightVote' : highlight}" class="small votes">Votes: {{ question.votes ?? 0 }}</div>
      @if(question.sticky_enabled && listReorderService.sortBy==='votes' ) {
        <div class="icons">
          <mat-icon
            class="material-symbols-outlined pin"
            vgIcon="keep"
            [style.transform]="'rotate(45deg)'"
          >
            Keep
          </mat-icon>
        </div>
      }@else{
        <div
          class="icons"
          *ngIf="votedFor ||  listReorderService.sortBy==='date'  && question.sticky_enabled else voteable"
        >
          <i class="ff thumbsup_voted"></i>
        </div>
        <ng-template #voteable>
          <div
            class="icons"
          >
            <i
              (click)="voteUAQ()"
              class="ff thumbsup"
              [ngClass]="listReorderService.sortBy === 'date' ? 'defaultColor' : 'defaultThump'"
            ></i>
          </div>
        </ng-template>
      }
    </div>
  }

</div>

